interface VideoProps {
  videoId: string
  title?: string
  width?: number | string
  height?: number | string
}

export default function Video({
  videoId,
  title = 'Youtube Video',
  width = '100%',
  height = '100%',
}: VideoProps) {
  return (
    <iframe
      className="self-stretch"
      src={`https://www.youtube.com/embed/${videoId}`}
      frameBorder="0"
      title={title}
      aria-hidden="true"
      width={width}
      height={height}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  )
}
